import classnames from "classnames";
import React from "react";
import { StyledComponentsPolymorphicProp } from "utils/commonTypes";
import featureFlags from "utils/featureFlags";

import { OldPanelContainer, PanelContainer } from "./style";

interface Props {
  colour?: string;
  className?: string;
  isMiniTile?: boolean;
  as?: StyledComponentsPolymorphicProp;
  children: React.ReactNode;
  testId?: string;
}

/**
 * Panel component which puts content inside a box with a coloured top border.
 *
 * Used for 'what's new' articles, summary tiles and the homepage sections.
 *
 * For use with the Bulma tile layout use TileChild.tsx.
 */

const PanelContainerComponent = featureFlags.rebrand
  ? PanelContainer
  : OldPanelContainer;
const Panel: React.FC<Props> = ({
  colour,
  className,
  isMiniTile,
  as,
  children,
  testId,
}) => (
  <PanelContainerComponent
    $colour={colour}
    className={classnames(className, isMiniTile && "mini-tile")}
    as={as}
    data-test-id={testId}
  >
    {children}
  </PanelContainerComponent>
);

export default Panel;
